import { Container, Stack, Typography } from "@octopus-energy/coral/atoms"
import { FormikTextField } from "@octopus-energy/coral/formik"
import { ZodFormik } from "@oefr/ui"
import { useTranslations } from "next-intl"
import { FormActions } from "@/components/organisms"
import { EnergyType } from "@/features/subscription"
import { useIsNavigating } from "@/hooks/useIsNavigating"
import { useRunMeterPointPmaxAnalysis } from "../../hooks/useRunMeterPointPmaxAnalysis"
import { MeterPointPmaxSchema } from "../../schemas/meterPointPmaxSchema"
import { HydrateMeterPowerAnalysisWizardForm, useMeterPowerAnalysisWizard } from "../../wizard"
import { MeterPointIdForm } from "../MeterPointIdForm"
import { MeterPowerAnalysisLoader } from "../MeterPowerAnalysisLoader"

const UserFields = () => {
    const t = useTranslations("PowerAnalysisForm")
    const { formValues } = useMeterPowerAnalysisWizard()

    return (
        <Container paddingY="lg">
            <Stack
                flexDirection="column"
                gap="lg"
            >
                <FormikTextField
                    name="user.firstName"
                    label={t("form.firstName")}
                    disabled={formValues.isFromDashboard}
                />
                <FormikTextField
                    name="user.lastName"
                    label={t("form.lastName")}
                    disabled={formValues.isFromDashboard}
                />
                <Typography textStyle="body2">{t("form.contents")}</Typography>
            </Stack>
        </Container>
    )
}

export const PowerAnalysisForm = () => {
    const t = useTranslations("PowerAnalysisForm")
    const isNavigating = useIsNavigating()
    const { formValues } = useMeterPowerAnalysisWizard()

    const [handleRunMeterPointPmaxAnalysis, { loading }] = useRunMeterPointPmaxAnalysis()

    return (
        <>
            <MeterPowerAnalysisLoader isLoading={loading} />
            <ZodFormik
                enableReinitialize
                initialValues={formValues}
                validationSchema={MeterPointPmaxSchema}
                onSubmit={handleRunMeterPointPmaxAnalysis}
            >
                <HydrateMeterPowerAnalysisWizardForm />
                <MeterPointIdForm energyType={EnergyType.Electricity} />

                <UserFields />

                <Stack
                    fullWidth
                    flexDirection="column"
                >
                    <FormActions step>
                        <FormActions.Accept
                            loading={false}
                            disabled={isNavigating || loading}
                        >
                            {t("callToAction")}
                        </FormActions.Accept>
                    </FormActions>
                </Stack>
            </ZodFormik>
        </>
    )
}

PowerAnalysisForm.messages = [
    "PowerAnalysisForm",
    ...MeterPowerAnalysisLoader.messages,
    ...MeterPointIdForm.messages,
] as const
